import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorEth20 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m11 7.31-2.728 4.288L11 12.726l2.728-1.128L11 7.311Zm.723-2.056 3.988 6.267a.861.861 0 0 1 .012.94l-4 6.285a.857.857 0 0 1-1.446 0L6.283 12.47a.856.856 0 0 1 .004-.946l3.99-6.27a.857.857 0 0 1 1.446 0ZM9.18 13.83l1.82 2.86 1.82-2.86-1.492.617a.857.857 0 0 1-.656 0L9.18 13.83Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M11 3.75A8.25 8.25 0 1 0 19.25 12a.75.75 0 0 1 1.5 0c0 5.385-4.365 9.75-9.75 9.75S1.25 17.385 1.25 12 5.615 2.25 11 2.25c2.003 0 3.867.605 5.417 1.642a.75.75 0 1 1-.834 1.247A8.208 8.208 0 0 0 11 3.75Z"
    />
    <path
      fill="#F7A600"
      d="M20.53 4.47a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22V12a.75.75 0 0 0 1.5 0V6.81l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5Z"
    />
  </svg>
);
export default SvgTwoColorEth20;
